// A gallery of the core (DESIGN.md «Галерея», review P3: a view of a collection is a component of the core, not a screen's styles):
// tiles in a grid from 180 px, each with its picture 4:3, a title and a line under it; a tile is a link to its record or page.

import type { MouseEvent, ReactNode } from 'react';
import s from './gallery.module.css';

export interface GalleryItem { key: string; href: string; media: ReactNode; title: string; sub?: string }

export function Gallery({ items, label, onOpen }: { items: GalleryItem[]; label: string; onOpen: (href: string) => void }) {
  const go = (e: MouseEvent, href: string) => { if (e.metaKey || e.ctrlKey || e.shiftKey) return; e.preventDefault(); onOpen(href); };
  return (
    <ul className={s.gallery} aria-label={label}>
      {items.map((it) => (
        <li key={it.key}>
          <a className={s.tile} href={it.href} onClick={(e) => go(e, it.href)}>
            <span className={s.media}>{it.media}</span>
            <span className={s.title}>{it.title}</span>
            {it.sub && <span className={s.sub}>{it.sub}</span>}
          </a>
        </li>
      ))}
    </ul>
  );
}
